import { render } from "./PreguntasFrecuentes.vue?vue&type=template&id=60274a2d&scoped=true&ts=true"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts"

import "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=60274a2d&lang=scss&scoped=true"

import exportComponent from "C:\\agentcloudALProd\\_work\\12\\s\\AEL.NominaElectronica.Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60274a2d"]])

export default __exports__